// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".l-appBar__logo img[data-v-067a960a]{max-height:35px}.l-appBar__menuBtn.lg[data-v-067a960a],.l-appBar__menuBtn.md[data-v-067a960a],.l-appBar__menuBtn.xl[data-v-067a960a]{position:absolute}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
